// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"runtime": 0
};

var installChunk = (data) => {
	var {__webpack_ids__, __webpack_modules__, __webpack_runtime__} = data;
	// add "modules" to the modules object,
	// then flag all "ids" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	for(moduleId in __webpack_modules__) {
		if(__webpack_require__.o(__webpack_modules__, moduleId)) {
			__webpack_require__.m[moduleId] = __webpack_modules__[moduleId];
		}
	}
	if(__webpack_runtime__) __webpack_runtime__(__webpack_require__);
	for(;i < __webpack_ids__.length; i++) {
		chunkId = __webpack_ids__[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[__webpack_ids__[i]] = 0;
	}

}

// no chunk on demand loading

// no prefetching

// no preloaded

__webpack_require__.C = installChunk;

// no on chunks loaded